"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseMessageEvent = exports.getSdkEventPayload = void 0;
var sdk_constants_1 = require("./sdk.constants");
var utils_1 = require("./utils");
var parseMessageEventData = function (eventData) {
    try {
        return JSON.parse(eventData);
    }
    catch (error) {
        return null;
    }
};
var isSdkEventPayload = function (parsedEventData) {
    return (0, utils_1.isPlainObject)(parsedEventData) && (0, utils_1.isString)(parsedEventData.event) && sdk_constants_1.HQO_SDK_EVENTS_SET.has(parsedEventData.event);
};
var getSdkEventPayload = function (detail) {
    if (isSdkEventPayload(detail)) {
        return {
            event: detail.event,
            data: detail.data,
        };
    }
    return null;
};
exports.getSdkEventPayload = getSdkEventPayload;
var parseMessageEvent = function (event) {
    var parsedEventData = (0, utils_1.isString)(event.data) ? parseMessageEventData(event.data) : null;
    return (0, exports.getSdkEventPayload)(parsedEventData);
};
exports.parseMessageEvent = parseMessageEvent;
//# sourceMappingURL=parse-event.utils.js.map